import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import styles from './autoplayCarousel.styl';
import { gallerySlideShape } from '../../shapes';

export const PaginationIndicators = ({
  slides,
  activeSlideIndex,
  onSlideClick,
  paginationLabel,
}) => {
  return (
    <div
      className={styles.pagination}
      role="group"
      aria-label={paginationLabel}
    >
      {slides?.map((slide, index) => {
        const isActive = index === activeSlideIndex;
        const slideKey = slide?.id ?? `slide-${index}`;
        return (
          <button
            key={`pagination-${slideKey}`}
            className={cx(styles.paginationDot, {
              [styles.active]: isActive,
            })}
            onClick={() => onSlideClick(index)}
            aria-label={`${isActive ? 'Current slide, ' : ''}Go to slide ${
              index + 1
            } of ${slides.length}`}
            aria-current={isActive ? 'true' : undefined}
            type="button"
          />
        );
      })}
    </div>
  );
};

PaginationIndicators.propTypes = {
  activeSlideIndex: PropTypes.number.isRequired,
  onSlideClick: PropTypes.func.isRequired,
  paginationLabel: PropTypes.string,
  slides: PropTypes.arrayOf(PropTypes.shape(gallerySlideShape)),
};
